import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useT } from "@/context/LanguageContext";
import { ArrowRight, Newspaper } from "@phosphor-icons/react";

const fmtDate = (s, lang) =>
  s ? new Date(s).toLocaleDateString(lang === "fr" ? "fr-FR" : lang === "sw" ? "sw-KE" : "en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export function BlogNews() {
  const { t, lang } = useT();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog", { params: { limit: 12 } })
      .then((r) => setPosts(r.data))
      .catch((e) => console.error("Failed to load blog news:", e));
  }, [lang]);

  if (!posts.length) return null;
  const items = [...posts, ...posts];

  return (
    <section data-testid="blog-news-ticker" className="border-t border-white/10 bg-ink py-10">
      <div className="mx-auto flex max-w-7xl items-end justify-between px-5 lg:px-8">
        <div>
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] font-semibold text-teal-light">
            <Newspaper size={16} weight="duotone" /> {t("blogNews.overline")}
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-white md:text-3xl">{t("blogNews.title")}</h2>
        </div>
        <Link to="/blog" data-testid="blog-news-viewall" className="group flex items-center gap-1.5 text-sm font-semibold text-teal-light hover:text-white">
          {t("blogNews.viewAll")} <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>

      <div className="group relative mt-7 overflow-hidden">
        <div
          className="flex w-max animate-marquee items-stretch gap-5 px-5 group-hover:[animation-play-state:paused]"
          style={{ animationDuration: "35s" }}
        >
          {items.map((p, i) => (
            <Link
              key={`${p.id}-${Math.floor(i / posts.length)}`}
              to={`/blog/${p.slug}`}
              data-testid="blog-news-card"
              className="w-[320px] shrink-0 overflow-hidden rounded-xl border border-white/10 bg-white/5 transition-all duration-300 hover:-translate-y-1 hover:border-teal/60"
            >
              <div className="h-36 overflow-hidden">
                <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover" loading="lazy" />
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between gap-2 text-[11px]">
                  <span className="font-semibold text-teal-light">{p.category}</span>
                  <span className="text-slate-400">{fmtDate(p.created_at, lang)}</span>
                </div>
                <p className="mt-2 font-heading text-sm font-semibold leading-snug text-white line-clamp-2">{p.title}</p>
                <p className="mt-1.5 text-xs leading-relaxed text-slate-400 line-clamp-2">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
